import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FeedbackService } from 'src/app/notifications/feedback.service';
import { SHARE_DETAILS_OPEN_STATE } from 'src/app/shared/models';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { ShareService } from 'src/app/shared/services/share.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { IShareData } from 'src/sync';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-share-leave',
  templateUrl: './share-leave.component.html',
  styleUrls: ['./share-leave.component.scss']
})
export class ShareLeaveComponent implements OnInit, OnDestroy {
  @Input() public shareData: IShareData;
  @Input() public openState: number;
  @Output() openStateChange: EventEmitter<number> = new EventEmitter();

  @Input() showDialog!: boolean;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  name: string = '';
  spinner: boolean = false;
  public isSmallScreen: boolean = false;
  private breakpointSubscription: Subscription;

  constructor(
    private shareService: ShareService,
    private feedbackService: FeedbackService,
    public breakpointObserver: BreakpointObserver,
    private snackbarService: SnackbarService,
    private broadcastService: BroadcastService
  ) { }

  ngOnInit() {
    this.breakpointSubscription = this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
    .subscribe((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 599px)']) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
      
    });  

    this.name = this.shareData['name'];
    this.showDialog = true;
  }

  ngOnDestroy(): void {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  public leaveShare = async () => {
    try {
      this.spinner = true;
      await this.shareService.leaveShare(
        this.shareData.shareId,
        this.shareData.sharememberId
      );
      this.broadcastService.broadcast('event:file-list.reload');
      this.broadcastService.broadcast('event:share-list.reload');
      this.spinner = false;
      this.snackbarService.showMessage('success', `Successfully left ${this.name}`)
      this.closeDialog();
    } catch (err) {
      this.snackbarService.showMessage('critical', 'Couldn’t complete action. Try again.');
      this.spinner = false;
      this.closeDialog();
    }
  }
  private openPopup(state: number) {
    this.openStateChange.next(state);

  }
  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(false);
      this.openPopup(state)
    }, 50);
  }
}
